import * as React from 'react';
import { Image } from 'antd';
import { useHeicSafeSrc } from '../../hooks/useHeicSafeSrc';
import { NoteMediaItem } from '../../utils/NoteMediaUtils';

// antd's own `.ant-image-img { height: auto }` and `.ant-image { position: relative }` load after
// the Tailwind sheet and win on equal specificity, so the image is sized inline — the same way
// NoteImageGrid and ProtectedImageThumbnails size theirs.
const IMAGE_STYLE: React.CSSProperties = {
	width: '100%',
	height: '100%',
	objectFit: 'cover',
	display: 'block',
};
const IMAGE_WRAPPER_STYLE: React.CSSProperties = { width: '100%', height: '100%' };

interface NotesMediaPhotoTileProps {
	item: NoteMediaItem;
	/** The square tile shell, plus sizing from the container. */
	className?: string;
	onOpen: (item: NoteMediaItem) => void;
}

/**
 * One photo in the media grid. Notes store absolute upload URLs, and a HEIC photo (an iPhone
 * upload) is converted to JPEG first so it renders outside Safari — the same normalization the
 * chat bubble's collage does.
 *
 * antd's own preview is off: photos and videos share one viewer here, and a preview group can only
 * hold images — so tapping a tile opens `NotesMediaViewer` at this item instead.
 */
const NotesMediaPhotoTile: React.FC<NotesMediaPhotoTileProps> = ({
	item,
	className = '',
	onOpen,
}) => {
	const safeSrc = useHeicSafeSrc(item.url);

	const handleClick = () => onOpen(item);

	return (
		<div className={`cursor-pointer bg-grey-4 ${className}`} onClick={handleClick}>
			<div className="absolute inset-0">
				<Image
					src={safeSrc}
					style={IMAGE_STYLE}
					wrapperStyle={IMAGE_WRAPPER_STYLE}
					preview={false}
					alt=""
				/>
			</div>
		</div>
	);
};

export default NotesMediaPhotoTile;
